/**
 * Generated by scripts/generate-drizzle-schema.mjs. Do not edit by hand.
 * This product's inputs: scripts/drizzle-schema.config.mjs.
 * Regenerate: bash scripts/client-schema-fresh.sh (data-model-change skill).
 */

import { DrizzleAppSchema, type PowerSyncSQLiteDatabase } from "@powersync/drizzle-driver";
import { index, integer, sqliteTable, text } from "drizzle-orm/sqlite-core";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

export const activity_recent = sqliteTable(
  "activity_recent",
  {
    id: text("id").primaryKey(),
    scope_id: text("scope_id"),
    branch_id: text("branch_id"),
    register_session_id: text("register_session_id"),
    entity_type: text("entity_type"),
    entity_id: text("entity_id"),
    action: text("action"),
    actor_user_id: text("actor_user_id"),
    actor_name: text("actor_name"),
    actor_device_id: text("actor_device_id"),
    platform: text("platform"),
    server_ts: text("server_ts"),
    client_ts: text("client_ts"),
    patch: text("patch"),
    batch_id: text("batch_id"),
    reverts_activity_id: text("reverts_activity_id"),
  },
  (table) => [
    /** ORDER BY server_ts DESC, id DESC in getActivityFeedQuery */
    index("activity_recent_by_ts").on(table.server_ts, table.id),
    /** WHERE entity_type = ? AND entity_id = ? in getEntityActivityQuery */
    index("activity_recent_by_entity").on(table.entity_type, table.entity_id, table.server_ts),
    /** WHERE register_session_id = ? in the shift activity view */
    index("activity_recent_by_session").on(table.register_session_id, table.server_ts),
  ],
);

export const attachment = sqliteTable(
  "attachment",
  {
    id: text("id").primaryKey(),
    filename: text("filename"),
    content_type: text("content_type"),
    size: integer("size"),
    url: text("url"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    user_id: text("user_id"),
    is_shared: integer("is_shared"),
    hash: text("hash"),
  },
  (table) => [
    /** WHERE user_id = ? in getAttachmentsByUserQuery / getHasLocalDataQuery */
    index("attachment_by_user").on(table.user_id),
  ],
);

export const branch = sqliteTable("branch", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  name: text("name"),
  address: text("address"),
  timezone: text("timezone"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const cash_movement = sqliteTable("cash_movement", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  register_session_id: text("register_session_id"),
  kind: text("kind"),
  amount: integer("amount"),
  reason: text("reason"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const combo = sqliteTable("combo", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  name: text("name"),
  price: integer("price"),
  tax_rate: integer("tax_rate"),
  is_available: integer("is_available"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const combo_item = sqliteTable("combo_item", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  combo_id: text("combo_id"),
  product_id: text("product_id"),
  qty: integer("qty"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const customer = sqliteTable("customer", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  name: text("name"),
  phone: text("phone"),
  email: text("email"),
  points: integer("points"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const dining_table = sqliteTable("dining_table", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  branch_id: text("branch_id"),
  name: text("name"),
  seats: integer("seats"),
  status: text("status"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const employee = sqliteTable("employee", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  branch_id: text("branch_id"),
  name: text("name"),
  pin: text("pin"),
  role: text("role"),
  is_active: integer("is_active"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const font_family = sqliteTable("font_family", {
  id: text("id").primaryKey(),
  family: text("family"),
  name: text("name"),
  category: text("category"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_variant = sqliteTable("font_variant", {
  id: text("id").primaryKey(),
  font_family_id: text("font_family_id"),
  weight: text("weight"),
  url: text("url"),
  created_at: text("created_at"),
  attachment_id: text("attachment_id"),
});

export const ingredient = sqliteTable(
  "ingredient",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    name: text("name"),
    unit: text("unit"),
    stock: integer("stock"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
    cost: integer("cost"),
  },
  (table) => [
    /** WHERE organization_id = ? in getIngredientsQuery */
    index("ingredient_by_org").on(table.organization_id),
  ],
);

export const loyalty_movement = sqliteTable("loyalty_movement", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  customer_id: text("customer_id"),
  order_id: text("order_id"),
  points_delta: integer("points_delta"),
  reason: text("reason"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

// Small dataset per user — indexes not needed for now.
export const member = sqliteTable("member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  role: text("role"),
  created_at: text("created_at"),
});

export const menu_category = sqliteTable("menu_category", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  name: text("name"),
  color: text("color"),
  icon: text("icon"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const menu_product = sqliteTable("menu_product", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  category_id: text("category_id"),
  name: text("name"),
  price: integer("price"),
  sku: text("sku"),
  is_available: integer("is_available"),
  tax_rate: integer("tax_rate"),
  prep_station: text("prep_station"),
  kind: text("kind"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const modifier_group = sqliteTable("modifier_group", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  name: text("name"),
  min_select: integer("min_select"),
  max_select: integer("max_select"),
  is_required: integer("is_required"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const modifier_option = sqliteTable("modifier_option", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  modifier_group_id: text("modifier_group_id"),
  name: text("name"),
  price_delta: integer("price_delta"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const order = sqliteTable("order", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  branch_id: text("branch_id"),
  type: text("type"),
  table_id: text("table_id"),
  waiter_user_id: text("waiter_user_id"),
  register_session_id: text("register_session_id"),
  status: text("status"),
  guests: integer("guests"),
  subtotal: integer("subtotal"),
  discount: integer("discount"),
  tax_total: integer("tax_total"),
  total: integer("total"),
  note: text("note"),
  opened_at: text("opened_at"),
  closed_at: text("closed_at"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
  employee_id: text("employee_id"),
  customer_id: text("customer_id"),
  points_redeemed: integer("points_redeemed"),
  void_reason: text("void_reason"),
  discount_reason: text("discount_reason"),
});

export const order_line = sqliteTable("order_line", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  order_id: text("order_id"),
  product_id: text("product_id"),
  name: text("name"),
  qty: integer("qty"),
  unit_price: integer("unit_price"),
  line_total: integer("line_total"),
  note: text("note"),
  kds_status: text("kds_status"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
  void_reason: text("void_reason"),
});

export const order_line_modifier = sqliteTable("order_line_modifier", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  order_line_id: text("order_line_id"),
  modifier_option_id: text("modifier_option_id"),
  name: text("name"),
  price_delta: integer("price_delta"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

// Small dataset — indexes not needed for now.
export const organization = sqliteTable("organization", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  logo: text("logo"),
  metadata: text("metadata"),
  created_at: text("created_at"),
});

export const payment = sqliteTable("payment", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  order_id: text("order_id"),
  register_session_id: text("register_session_id"),
  method: text("method"),
  amount: integer("amount"),
  tendered: integer("tendered"),
  change_given: integer("change_given"),
  paid_at: text("paid_at"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
  tip: integer("tip"),
  employee_id: text("employee_id"),
});

export const product_modifier_group = sqliteTable("product_modifier_group", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  product_id: text("product_id"),
  modifier_group_id: text("modifier_group_id"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const product_variant = sqliteTable("product_variant", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  product_id: text("product_id"),
  name: text("name"),
  price: integer("price"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const promotion = sqliteTable("promotion", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  name: text("name"),
  kind: text("kind"),
  value: integer("value"),
  start_hour: integer("start_hour"),
  end_hour: integer("end_hour"),
  is_active: integer("is_active"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const purchase_order = sqliteTable("purchase_order", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  branch_id: text("branch_id"),
  supplier_id: text("supplier_id"),
  status: text("status"),
  total: integer("total"),
  note: text("note"),
  received_at: text("received_at"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const purchase_order_line = sqliteTable("purchase_order_line", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  purchase_order_id: text("purchase_order_id"),
  ingredient_id: text("ingredient_id"),
  qty: integer("qty"),
  unit_cost: integer("unit_cost"),
  line_total: integer("line_total"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const recipe_item = sqliteTable(
  "recipe_item",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    product_id: text("product_id"),
    ingredient_id: text("ingredient_id"),
    qty: integer("qty"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE organization_id = ? (sync scoping) */
    index("recipe_item_by_org").on(table.organization_id),
    /** WHERE product_id = ? in getRecipeItemsQuery */
    index("recipe_item_by_product").on(table.product_id),
  ],
);

export const register_session = sqliteTable("register_session", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  branch_id: text("branch_id"),
  cashier_user_id: text("cashier_user_id"),
  opening_float: integer("opening_float"),
  counted_total: integer("counted_total"),
  status: text("status"),
  opened_at: text("opened_at"),
  closed_at: text("closed_at"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const reservation = sqliteTable("reservation", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  branch_id: text("branch_id"),
  table_id: text("table_id"),
  customer_id: text("customer_id"),
  customer_name: text("customer_name"),
  phone: text("phone"),
  party_size: integer("party_size"),
  reserved_at: text("reserved_at"),
  kind: text("kind"),
  status: text("status"),
  note: text("note"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

// Active user sessions — small dataset, no indexes.
export const session = sqliteTable("session", {
  id: text("id").primaryKey(),
});

export const stock_movement = sqliteTable(
  "stock_movement",
  {
    id: text("id").primaryKey(),
    organization_id: text("organization_id"),
    ingredient_id: text("ingredient_id"),
    order_id: text("order_id"),
    qty_delta: integer("qty_delta"),
    reason: text("reason"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
    purchase_order_id: text("purchase_order_id"),
  },
  (table) => [
    /** WHERE organization_id = ? (sync scoping) */
    index("stock_movement_by_org").on(table.organization_id),
    /** WHERE ingredient_id = ? in getStockMovementsQuery */
    index("stock_movement_by_ingredient").on(table.ingredient_id),
  ],
);

export const supplier = sqliteTable("supplier", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  name: text("name"),
  contact: text("contact"),
  phone: text("phone"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

// Small global dataset (~20 themes) — indexes not needed.
export const themes = sqliteTable("themes", {
  id: text("id").primaryKey(),
  name: text("name"),
  background: text("background"),
  surface: text("surface"),
  accent: text("accent"),
  glow_colors: text("glow_colors"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  is_dark: integer("is_dark"),
  foreground: text("foreground"),
  field_background: text("field_background"),
  danger: text("danger"),
  success: text("success"),
  warning: text("warning"),
  muted: text("muted"),
  pattern_type: text("pattern_type"),
  pattern_opacity: integer("pattern_opacity"),
  pair_id: text("pair_id"),
  font_normal: text("font_normal"),
  font_medium: text("font_medium"),
  font_semibold: text("font_semibold"),
  font_bold: text("font_bold"),
  radius: text("radius"),
  surface_foreground: text("surface_foreground"),
  surface_secondary: text("surface_secondary"),
  surface_secondary_foreground: text("surface_secondary_foreground"),
  surface_tertiary: text("surface_tertiary"),
  surface_tertiary_foreground: text("surface_tertiary_foreground"),
  overlay: text("overlay"),
  overlay_foreground: text("overlay_foreground"),
  default: text("default"),
  default_foreground: text("default_foreground"),
  accent_foreground: text("accent_foreground"),
  field_foreground: text("field_foreground"),
  field_placeholder: text("field_placeholder"),
  field_border: text("field_border"),
  danger_foreground: text("danger_foreground"),
  success_foreground: text("success_foreground"),
  warning_foreground: text("warning_foreground"),
  segment: text("segment"),
  segment_foreground: text("segment_foreground"),
  border: text("border"),
  focus: text("focus"),
  link: text("link"),
  surface_shadow: text("surface_shadow"),
  overlay_shadow: text("overlay_shadow"),
  field_shadow: text("field_shadow"),
  muted_foreground: text("muted_foreground"),
  divider: text("divider"),
  glass_background: text("glass_background"),
  glass_border: text("glass_border"),
  glass_highlight: text("glass_highlight"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
});

// Only 1 row per user — indexes not needed.
export const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  name: text("name"),
  email: text("email"),
  email_verified: integer("email_verified"),
  image: text("image"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  locale: text("locale"),
  global_theme_id: text("global_theme_id"),
  is_blur: integer("is_blur"),
  font_family: text("font_family"),
  follow_device_theme: integer("follow_device_theme"),
  role: text("role"),
});

export const drizzleSchema = {
  activity_recent,
  attachment,
  branch,
  cash_movement,
  combo,
  combo_item,
  customer,
  dining_table,
  employee,
  font_family,
  font_variant,
  ingredient,
  loyalty_movement,
  member,
  menu_category,
  menu_product,
  modifier_group,
  modifier_option,
  order,
  order_line,
  order_line_modifier,
  organization,
  payment,
  product_modifier_group,
  product_variant,
  promotion,
  purchase_order,
  purchase_order_line,
  recipe_item,
  register_session,
  reservation,
  session,
  stock_movement,
  supplier,
  themes,
  user,
};

export const AppSchema = new DrizzleAppSchema(drizzleSchema);

export type Database = (typeof AppSchema)["types"];

/**
 * Type helper for the Drizzle database instance wrapped with PowerSync.
 */
export type PowerSyncDrizzleDB = PowerSyncSQLiteDatabase<typeof drizzleSchema>;

export const USER_DATA_TABLES = ["attachment"] as const;

export type ActivityRecent = InferSelectModel<typeof activity_recent>;
export type ActivityRecentInsert = InferInsertModel<typeof activity_recent>;
export type ActivityRecentRecord = ActivityRecent;
export type Attachment = InferSelectModel<typeof attachment>;
export type AttachmentInsert = InferInsertModel<typeof attachment>;
export type AttachmentRecord = Attachment;
export type Branch = InferSelectModel<typeof branch>;
export type BranchInsert = InferInsertModel<typeof branch>;
export type BranchRecord = Branch;
export type CashMovement = InferSelectModel<typeof cash_movement>;
export type CashMovementInsert = InferInsertModel<typeof cash_movement>;
export type CashMovementRecord = CashMovement;
export type Combo = InferSelectModel<typeof combo>;
export type ComboInsert = InferInsertModel<typeof combo>;
export type ComboRecord = Combo;
export type ComboItem = InferSelectModel<typeof combo_item>;
export type ComboItemInsert = InferInsertModel<typeof combo_item>;
export type ComboItemRecord = ComboItem;
export type Customer = InferSelectModel<typeof customer>;
export type CustomerInsert = InferInsertModel<typeof customer>;
export type CustomerRecord = Customer;
export type DiningTable = InferSelectModel<typeof dining_table>;
export type DiningTableInsert = InferInsertModel<typeof dining_table>;
export type DiningTableRecord = DiningTable;
export type Employee = InferSelectModel<typeof employee>;
export type EmployeeInsert = InferInsertModel<typeof employee>;
export type EmployeeRecord = Employee;
export type FontFamily = InferSelectModel<typeof font_family>;
export type FontFamilyInsert = InferInsertModel<typeof font_family>;
export type FontFamilyRecord = FontFamily;
export type FontVariant = InferSelectModel<typeof font_variant>;
export type FontVariantInsert = InferInsertModel<typeof font_variant>;
export type FontVariantRecord = FontVariant;
export type Ingredient = InferSelectModel<typeof ingredient>;
export type IngredientInsert = InferInsertModel<typeof ingredient>;
export type IngredientRecord = Ingredient;
export type LoyaltyMovement = InferSelectModel<typeof loyalty_movement>;
export type LoyaltyMovementInsert = InferInsertModel<typeof loyalty_movement>;
export type LoyaltyMovementRecord = LoyaltyMovement;
export type Member = InferSelectModel<typeof member>;
export type MemberInsert = InferInsertModel<typeof member>;
export type MemberRecord = Member;
export type MenuCategory = InferSelectModel<typeof menu_category>;
export type MenuCategoryInsert = InferInsertModel<typeof menu_category>;
export type MenuCategoryRecord = MenuCategory;
export type MenuProduct = InferSelectModel<typeof menu_product>;
export type MenuProductInsert = InferInsertModel<typeof menu_product>;
export type MenuProductRecord = MenuProduct;
export type ModifierGroup = InferSelectModel<typeof modifier_group>;
export type ModifierGroupInsert = InferInsertModel<typeof modifier_group>;
export type ModifierGroupRecord = ModifierGroup;
export type ModifierOption = InferSelectModel<typeof modifier_option>;
export type ModifierOptionInsert = InferInsertModel<typeof modifier_option>;
export type ModifierOptionRecord = ModifierOption;
export type Order = InferSelectModel<typeof order>;
export type OrderInsert = InferInsertModel<typeof order>;
export type OrderRecord = Order;
export type OrderLine = InferSelectModel<typeof order_line>;
export type OrderLineInsert = InferInsertModel<typeof order_line>;
export type OrderLineRecord = OrderLine;
export type OrderLineModifier = InferSelectModel<typeof order_line_modifier>;
export type OrderLineModifierInsert = InferInsertModel<typeof order_line_modifier>;
export type OrderLineModifierRecord = OrderLineModifier;
export type Organization = InferSelectModel<typeof organization>;
export type OrganizationInsert = InferInsertModel<typeof organization>;
export type OrganizationRecord = Organization;
export type Payment = InferSelectModel<typeof payment>;
export type PaymentInsert = InferInsertModel<typeof payment>;
export type PaymentRecord = Payment;
export type ProductModifierGroup = InferSelectModel<typeof product_modifier_group>;
export type ProductModifierGroupInsert = InferInsertModel<typeof product_modifier_group>;
export type ProductModifierGroupRecord = ProductModifierGroup;
export type ProductVariant = InferSelectModel<typeof product_variant>;
export type ProductVariantInsert = InferInsertModel<typeof product_variant>;
export type ProductVariantRecord = ProductVariant;
export type Promotion = InferSelectModel<typeof promotion>;
export type PromotionInsert = InferInsertModel<typeof promotion>;
export type PromotionRecord = Promotion;
export type PurchaseOrder = InferSelectModel<typeof purchase_order>;
export type PurchaseOrderInsert = InferInsertModel<typeof purchase_order>;
export type PurchaseOrderRecord = PurchaseOrder;
export type PurchaseOrderLine = InferSelectModel<typeof purchase_order_line>;
export type PurchaseOrderLineInsert = InferInsertModel<typeof purchase_order_line>;
export type PurchaseOrderLineRecord = PurchaseOrderLine;
export type RecipeItem = InferSelectModel<typeof recipe_item>;
export type RecipeItemInsert = InferInsertModel<typeof recipe_item>;
export type RecipeItemRecord = RecipeItem;
export type RegisterSession = InferSelectModel<typeof register_session>;
export type RegisterSessionInsert = InferInsertModel<typeof register_session>;
export type RegisterSessionRecord = RegisterSession;
export type Reservation = InferSelectModel<typeof reservation>;
export type ReservationInsert = InferInsertModel<typeof reservation>;
export type ReservationRecord = Reservation;
export type Session = InferSelectModel<typeof session>;
export type SessionInsert = InferInsertModel<typeof session>;
export type SessionRecord = Session;
export type StockMovement = InferSelectModel<typeof stock_movement>;
export type StockMovementInsert = InferInsertModel<typeof stock_movement>;
export type StockMovementRecord = StockMovement;
export type Supplier = InferSelectModel<typeof supplier>;
export type SupplierInsert = InferInsertModel<typeof supplier>;
export type SupplierRecord = Supplier;
export type Themes = InferSelectModel<typeof themes>;
export type ThemesInsert = InferInsertModel<typeof themes>;
export type ThemesRecord = Themes;
export type User = InferSelectModel<typeof user>;
export type UserInsert = InferInsertModel<typeof user>;
export type UserRecord = User;
